<script setup>
import {computed} from "vue";

const props = defineProps({
  value: {
    type: Number,
    required: true,
  },
  compare: {
    type: Number,
    required: true,
  },
  inverted: {
    type: Boolean,
    default: false,
  },
  position: {
    type: String,
    default: 'absolute',
  },
  asPercentage: {
    type: Boolean,
    default: false,
  },
});

const diff = computed(() => props.value - props.compare)

const percentage = computed(() => {
  const percentage = ((props.value - props.compare) / props.value) * 100;

  return percentage > 0 ? percentage : percentage * -1;
})

const color = computed(() => {
  if (diff.value < 0 && !props.inverted) {
    return 'red';
  }

  if (diff.value > 0 && props.inverted) {
    return 'red';
  }

  return 'everest';
})
</script>

<template>
  <div
    class="tw-w-auto tw-inline-block tw-relative tooltipster tw-cursor-default"
    :title="compare"
  >
    <span
      v-if="diff !== undefined"
      :class="[
        `tw-rounded tw-py-1 tw-px-2 tw-text-xs tw-flex tw-items-center tw-gap-1 tw-w-auto tw-ml-2 tw-font-medium tw-${position} -tw-top-4`,
        `tw-bg-${color}-lightest tw-text-${color}`,
      ]"
    >
      <svg-vue
        v-if="diff !== 0 && diff !== undefined"
        icon="icons/chevron"
        :class="[
          'tw-h-2 tw-w-2',
          {
            'tw-rotate-180' : diff > 0,
          },
        ]"
      />
      <span v-if="!asPercentage">{{ (diff >= 0 ? diff : diff * -1).toLocaleString() }}</span>
      <span v-else>{{ percentage.toFixed(0) }}%</span>
    </span>
  </div>
</template>